// This file was generated by "make codegen/iam". DO NOT EDIT.
// source: <server_repo_dir>/nexus/integrations/integrations.actions.go

import { type Scope } from "~/hooks/useScope";
import { GET_TOKEN_FOR_INTEGRATION } from "./action";

export function canGetTokenForIntegration(scope: Scope): boolean {
  return scope.iamActions.includes(GET_TOKEN_FOR_INTEGRATION);
}
